<!--
 * @Copyright: 12308
 * @Author: ZhangYanshuang
 * @Date: 2020-04-13 14:57:05
 * @LastEditTime: 2020-12-21 15:59:19
 * @Description: 
 -->
<template>
    <div class="tab-page">
        <ul class="tab-tilte clear">
            <!-- <li
                v-for="(content, index) in $route.meta.list"
                :key="content.id"
                @click="send(index, content.id)"
                :id="content.id"
                :class="{ active: current === index }"
            >
                {{ content.title }}
            </li> -->
            <li
                v-for="(content, index) in contents"
                :key="content.id"
                @click="send(index, content.id)"
                :id="content.id"
                :class="{ active: current === index }"
            >
                {{ content.title }}
            </li>
        </ul>

        <div class="tabBox">
            <div class="tab-content">
                <!-- <div class="title">{{ message.title }}</div> -->
                <div class="tabCOn" v-html="message.info">
                    {{ message.info }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getContent, getList } from "../../../api/gm/api-content";
export default {
    data() {
        return {
            contents: {},
            message: {},
            current: 0,
            viewContentSearch: {
                productid: this.$route.meta.pid,
                relationid: this.$route.meta.rid,
                relationmodel: "tab",
                isdelete: false
            }
        };
    },
    created() {
        this.getData();
        var con = this.$route.meta.list;
        if (con) {
            this.send(0, this.$route.meta.list[0].id);
        } else {
            this.message = {};
        }
    },
    watch: {
        $route: {
            handler: function() {
                (this.viewContentSearch.productid = this.$route.meta.pid),
                    (this.viewContentSearch.relationid = this.$route.meta.rid),
                    this.getData();
                var con = this.$route.meta.list;
                if (con) {
                    this.send(0, this.$route.meta.list[0].id);
                } else {
                    this.message = {};
                }
            }
        }
    },
    methods: {
        send(index, id) {
            getContent(id).then(res => {
                if (res.code === 0) {
                    this.message = res.data;
                    this.current = index;

                    this.$nextTick(() => {
                        let video = document.querySelector("video");
                        video.setAttribute("controlsList", "nodownload");

                        var options = {
                            attributes: true,
                            childList: true,
                            subtree: true,
                            attributeOldValue: true
                        };

                        function callback(mutationsList, observer) {
                            if (mutationsList[0].oldValue === "nodownload") {
                                video.setAttribute(
                                    "controlsList",
                                    "nodownload"
                                );
                            }
                            console.log(mutationsList);
                            console.log(observer);
                        }

                        var mutationObserver = new MutationObserver(callback);

                        mutationObserver.observe(video, options);
                    });
                } else {
                    console.log(res.msg);
                }
            });
        },
        getData() {
            getList(this.viewContentSearch).then(res => {
                if (res.code === 0) {
                    this.contents = res.data;
                    if (this.contents.length > 1) {
                        this.havaTab = true;
                    }
                } else {
                    console.log(res.msg);
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
/deep/html,
body {
    overflow: unset;
}
.clear:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
}
.tab-page {
    ul {
        padding: 0;
        margin: 1.6vw 0px 0px 0px;
        background: #607bc6;
        width: fit-content;
        border-radius: 100px;
        li {
            width: auto;
            min-width: 60px;
            height: 30px;
            float: left;
            border-radius: 100px;
            font-style: normal;
            list-style: none;
            text-align: center;
            font-size: 20px;
            color: #fff;
            line-height: 30px;
            padding: 0.6vw 30px;
            cursor: pointer;
            &.active {
                background: #0732a3;
            }
            &:hover {
                background: #0732a3;
            }
        }
    }
}

.tab-content {
    margin: 30px 0px;
    .tabCOn {
        font-size: 16px;
        color: #464646;
        line-height: 30px;
        /deep/video {
            margin: 0 auto;
            display: block;
            max-width: 100% !important;
        }
    }
}

@media (max-width: 1024px) {
    .tab-page {
        ul {
            li {
                padding: 7px 15px;
                height: 24px;
                line-height: 24px;
                font-size: 15px;
            }
        }
    }
    .tab-content {
        .tabCOn {
            font-size: 14px;
            line-height: 24px;
            /deep/img {
                width: auto !important;
                margin-right: 0px !important;
                max-width: 100%;
            }
            /deep/.title {
                font-size: 16px !important;
                /deep/img {
                    max-width: 22px;
                    max-height: 22px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/components/tab-page.vue